<div class="login-bg">
  <div class="trapezium"></div>
  <div class="logo-container">
    <div class="logo-text">PVT Lab</div>
  </div>
  <div class="login-container">
    <h2>Login</h2>
    <form>
      <button type="button" (click)="Login()">Login</button>
    </form>
  </div>
</div>